<template>
    <div>
        <div id="assignContent" data-backdrop="static" data-keyboard="false" class="modal fade" role="dialog">
            <div class="modal-dialog modal-md modal-dialog-centered">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg text-black">
                            Manage Section Content
                        </h4>
                        <button type="button" dusk="modal-close-button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                @click="cancelAssignContent()"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="mb-2">
                                <div class="form-group list-all-template-section-for-selection">
                                    <input  class="form-control"
                                            type="text"
                                            v-model="proposalContentGroupName"
                                            id="proposal_content_group_manage_name">
                                </div>
                            </div>
                            <div class="mb-2">
                                <div class="form-group list-all-template-section-for-selection">
                                    <label class="text-black font-light text-sm">Add Contents</label>
                                    <multiselect
                                        id="allTemplateSections"
                                        :hide-selected="true"
                                        :internal-search="true"
                                        v-model="selectedContents"
                                        :options="allContents"
                                        :multiple="true"
                                        :close-on-select="false"
                                        :clear-on-select="false"
                                        :preserve-search="false"
                                        :taggable="false"
                                        open-direction="below"
                                        placeholder="Search and Select..."
                                        :showLabels="false"
                                        label="template_name"
                                        track-by="id"
                                        :preselect-first="false"
                                    >
                                    </multiselect>
                                </div>
                            </div>
                        </form>
                        <div class="w-100 bg-white px-4 py-2 selected-template-section-list">
                            <div v-if="selectedContents.length > 0">
                                <div class="row text-black font-light mb-2" v-for="selectedContent in selectedContents">
                                    <div class="col-md-10 text-left font-light m-0 p-0">
                                        {{selectedContent.template_name}}
                                    </div>
                                    <div class="col-md-2 text-right">
                                        <i class="fa fa-trash pointer" aria-hidden="true" @click="removeSelectedContent(selectedContent)"></i>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="text-sm text-black text-center m-0 p-0">
                                No Content Selected
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button  id="cancel-manage-section-listing-modal" name="cancel-manage-section-listing-modal"
                                 @click="cancelAssignContent()"
                                 class="px-3 py-1 rounded-full text-teal focus:outline-none">
                            Cancel
                        </button>
                        <button name="save-proposal-type"
                                @click="saveAssignContent()"
                                class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div id="proposal-content-group-rename" data-backdrop="static" data-keyboard="false" class="modal fade" role="dialog">
            <div class="modal-dialog modal-md modal-dialog-centered">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg text-black">
                            Manage Section Content Name
                        </h4>
                        <button type="button" dusk="modal-close-button" @click="proposalContentGroupCancel()"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="mb-2">
                                <div class="form-group">
                                    <label class="text-black font-light text-sm">Section Content Name</label>
                                    <input  class="form-control"
                                            type="text"
                                            v-model="proposalContentGroupName"
                                            id="proposal_content_group_name">
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <div>
                            <button name="cancel-proposal-template"
                                    @click="proposalContentGroupCancel()"
                                    class="px-3 py-1 rounded-full text-teal focus:outline-none">
                                Cancel
                            </button>
                            <button  id="update-proposal-type" name="update-proposal-template"
                                     @click="updateProposalContentGroup()"
                                     class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                                Update
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="proposal-settings-template-manage-div" class="p-3">
            <div class="row">
                <div class="col-md-6 float-left">
                    <h5 class="mt-1 float-left mr-3">{{ proposalContentGroupName }}</h5><i class="fa fa-pencil edit-icon-proposal-template-manage pointer" aria-hidden="true" @click="renameContentGroup()"></i>
                </div>
                <div class="col-md-6 float-right text-right">
                    <div class="col-md-11 float-left pr-0">
                        <button id="add-proposal-template" name="add-proposal-template" @click="assignContent()"
                                class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 text-white focus:outline-none rounded add-new-template-button">
                            Manage Section Content
                        </button>
                    </div>
                    <div class="col-md-1 float-left mt-2">
                        <div class="dropdown open dropleft">
                            <button type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true"
                                    aria-expanded="false">
                                <svg class="fill-current h-4 w-4" enable-background="new 0 0 515.555 515.555"
                                     viewBox="0 0 515.555 515.555" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="m303.347 18.875c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                    <path
                                        d="m303.347 212.209c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                    <path
                                        d="m303.347 405.541c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                </svg>
                            </button>

                            <div class="dropdown-menu">
                                <a class="dropdown-item" @click="renameContentGroup()">Rename</a>
                                <a class="dropdown-item" @click="deleteContentGroup()">Delete</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="proposal-template-manage-listing-div mt-3">
                <div class="proposal-template-manage-listing-heading">
                    <div class="row proposal-template-manage-listing-heading-row pt-2 pb-2 text-black">
                        <div class="col-md-5 float-left">
                            Content
                        </div>
                        <div class="col-md-5 float-left">
                            Last Updated
                        </div>
                        <div class="col-md-2 float-left">
                        </div>
                    </div>
                </div>
                <div class="text-black font-light row" v-if="proposalContents.length > 0">
                    <div class="proposal-template-manage-listing w-100 px-3 py-2 proposal-template-listing-hover" v-for="proposalContent in proposalContents">
                        <div class="col-md-5 float-left p-0">
                            <img :src="baseUrl+'/images/drag-icon.png'" class="proposal-setting-drag-icon float-left pt-1 mr-1">
                            <div class="proposal-type-section-name-new pl-1 float-left mr-1" :id="'content'+proposalContent.id" :title="proposalContent.template_name">{{ proposalContent.template_name }}</div>
                        </div>
                        <div class="col-md-5 float-left">
                            {{ formatUpdateDate(proposalContent.updated_at) }}
                        </div>
                        <div class="col-md-2 float-left pr-3 text-right">
                            <div class="dropdown open">
                                <button type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true"
                                        aria-expanded="false">
                                    <svg class="fill-current h-4 w-4" enable-background="new 0 0 515.555 515.555"
                                         viewBox="0 0 515.555 515.555" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="m303.347 18.875c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                        <path
                                            d="m303.347 212.209c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                        <path
                                            d="m303.347 405.541c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                    </svg>
                                </button>

                                <div class="dropdown-menu">
                                    <a class="dropdown-item" @click="duplicateContent(proposalContent)">Duplicate</a>
                                    <a class="dropdown-item" @click="removeContentFromContentGroup(proposalContent)">Remove</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="text-black font-light mt-3 text-center">
                    No Content is Assigned to this Section Content
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import axios from "axios";
import Form from "../../../utils/form";
import Multiselect from "vue-multiselect";
import Swal from "sweetalert2";

export default {
    name: "proposal-settings-content-groups-manage",
    props:['proposalContentGroup', 'baseUrl'],
    components: {Multiselect},
    data() {
        return {
            selectedProposalContentGroup:(this.proposalContentGroup)? this.proposalContentGroup:null,
            proposalContents:[],
            proposalContentGroupName:(this.proposalContentGroup)? this.proposalContentGroup.name:null,
            selectedContents:[],
            allContents:[]
        }
    },
    mounted(){
        this.$nextTick(() => {
            this.fetchContentFromContentGroup();
        });
    },
    methods: {
        formatUpdateDate(updatedAt){
            return moment.utc(updatedAt).local().format('MM/DD/YYYY hh:mm A')
        },
        fetchContentFromContentGroup(){
            axios.post(route('api.proposal-content-group.manage.specific-content'), {contentGroup:this.selectedProposalContentGroup})
            .then((response) => {
                this.proposalContents = response.data.contents;
                this.selectedContents = response.data.contents;
            });
        },
        renameContentGroup(){
            $('#proposal-content-group-rename').modal('show');
        },
        proposalContentGroupCancel(){
            this.proposalContentGroupName = this.selectedProposalContentGroup.name;
            $('#proposal-content-group-rename').modal('hide');
        },
        updateProposalContentGroup(){
            if(this.proposalContentGroupName.trim() == '' || this.proposalContentGroupName == undefined){
                this.getToast().fire({
                    type: 'error',
                    title: 'Please enter section content name'
                });
                this.proposalContentGroupName = this.selectedProposalContentGroup.name;
                return false;
            }
            axios.post(route('api.proposal-content-group.rename'), {name:this.proposalContentGroupName, contentGroup: this.selectedProposalContentGroup}).then((response) => {
                if(response.data.status == 'success'){
                    this.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    this.selectedProposalContentGroup = response.data.contentGroupObject;
                    this.proposalContentGroupCancel();
                }
            });
        },
        deleteContentGroup(){
            Swal.fire({
                title             : "Are you sure?",
                text              : "Once deleted, you will not be able to recover this section content!",
                icon              : "warning",
                buttons           : true,
                showCancelButton  : true,
                confirmButtonColor: 'red',
                confirmButtonText : 'I\'m sure!',
                closeOnConfirm    : true,
                closeOnCancel     : true,
            }).then(result => {
                if (result.value) {
                    axios.post(route('api.proposal-content-group.delete'), {contentGroup: this.selectedProposalContentGroup}).then((response) => {
                        if(response.data.status == 'success'){
                            this.getToast().fire({
                                type: 'success',
                                title: response.data.message
                            });
                            setTimeout(() => {
                                this.backToTemplateListing();
                            }, 1000)
                        }
                    });
                }
            });
        },
        backToTemplateListing(){
            Bus.$emit('changeSettingType', {selectedData: null, type:'tabs'});
        },
        removeContentFromContentGroup(proposalContent){
            axios.post(route('api.proposal-content-group.manage.remove-specific-content'), {content: proposalContent, contentGroup: this.selectedProposalContentGroup})
            .then((response) => {
                if(response.data.status == 'success') {
                    this.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    this.fetchContentFromContentGroup();
                }
            });
        },
        assignContent(){
            axios.post(route('api.proposal-content-group.manage.all-content')).then((response) => {
                if(response.data.status == 'success'){
                    this.allContents = response.data.contents;
                    $('#assignContent').modal('show');
                }
            });
        },
        cancelAssignContent(){
            $('#assignContent').modal('hide');
            this.fetchContentFromContentGroup();
            this.proposalContentGroupName = this.selectedProposalContentGroup.name;
        },
        saveAssignContent(fromWhere = null){
            if(this.proposalContentGroupName.trim() == '' || this.proposalContentGroupName == undefined){
                this.getToast().fire({
                    type: 'error',
                    title: 'Please enter section content name'
                });
                this.proposalContentGroupName = this.selectedProposalContentGroup.name;
                return false;
            }
            axios.post(route('api.proposal-content-group.manage.update'), {name:this.proposalContentGroupName, contentGroup: this.selectedProposalContentGroup, content:this.selectedContents})
                .then((response) => {
                    if(response.data.status == 'success'){
                        if(!fromWhere){
                            this.getToast().fire({
                                type: 'success',
                                title: response.data.message
                            });
                        }
                        this.selectedProposalContentGroup = response.data.contentGroupObj;
                        this.fetchContentFromContentGroup();
                        this.cancelAssignContent();
                    }
            });
        },
        removeSelectedContent(selectedContent){
            this.selectedContents.splice(
                this.selectedContents.findIndex(
                    item => item.id == selectedContent.id)
                , 1);
        },
        duplicateContent(proposalContent){
            axios.post(route('api.proposal-content.duplicate'), {content: proposalContent}).then((response) => {
                if(response.data.status == 'success'){
                    this.getToast().fire({
                        type: 'success',
                        title: 'Content duplicated successfully.'
                    });
                    this.addDuplicatedContentToSelectedContent(response.data.proposalContent);
                }
            });
        },
        addDuplicatedContentToSelectedContent(content){
            let newContent = {};
            newContent = {
                id: content.id,
                template_name: content.template_name,
                updated_at: content.updated_at
            };
            this.selectedContents.push(newContent);
            this.saveAssignContent('duplicate');
        }
    }
};
</script>

<style>
#proposal-settings-template-manage-div {
    padding: 5px 0;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.15);
    background-color:#fff;
    min-height: 80vh;
    border-radius:5px;
}
#proposal-settings-template-manage-div h5{
    color: #222;
    font-weight: 400;
    padding: 5px 0px;
}
#proposal-settings-template-manage-div .add-new-template-button{
    height: 40px;
    font-weight: 300;
}
.proposal-template-manage-listing-heading-row{
    background: #f4f5f6;
    font-weight: 500;
}
.proposal-template-manage-listing .proposal-type-section-name-new {
    color: #000;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 280px;
    font-weight: 300;
}
.proposal-template-manage-listing .proposal-type-section-name-new-width {
    width: 170px;
}
.proposal-setting-drag-icon{
    width:15px;
}
.content-type-div{
    padding-left: 12px;
}
.proposal-template-listing-hover:hover {
    background: #f5f5f5;
}
.section-disabled-div {
    font-size: 12px;
    float: left;
    background: #DC3545;
    color: white;
    padding: 3px 5px;
    border-radius: 5px;
}
.coverCheckboxDiv {
    width: 50%;
    display: inline-block;
    font-size: 15px;
    color: #000;
    font-weight: 300;
}
#proposal-settings-template-manage-div .dropdown-item {
    font-weight: 300;
    font-size: 15px;
}
.proposal-template-listing-hover {
    -webkit-user-drag: element !important;
}
.selected-template-section-list{
    border-radius: 5px;
    border: 1px solid #ddd;
    max-height: 40vh;
    overflow: scroll;
}
.edit-icon-proposal-template-manage {
    font-size: 20px;
    margin-top: 10px;
}
</style>
